var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNitexLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 40,
    viewBox: "0 0 246 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H8.01261L20.9887 22.3055C22.2418 24.4897 23.7176 27.8944 23.7176 27.8944H23.822C23.822 27.8944 23.6062 23.7545 23.6062 20.9636V0H31.403V39.9715H23.7733L10.47 17.8872C9.20997 15.7602 7.68542 12.3555 7.68542 12.3555C7.68542 12.3555 7.7968 16.5525 7.7968 19.3433V39.9715H0V0Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.29 0H56.3818V39.9715H64.29V0Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.269 0H120.616V6.8237H108.893V39.9715H100.985V6.8237H89.269V0Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.595 0H174.276V6.8237H153.503V15.7673H171.714V22.4197H153.503V33.212H174.436V39.9715H145.595V0Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.009 19.0933L200.341 0.0283203H209.231L216.429 12.6622H216.534L223.732 0.0283203H232.35L220.898 19.0362L233.826 39.9998H224.602L216.645 25.4102H216.534L208.465 39.9998H199.416L212.009 19.0933Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.553 6.06686C233.553 2.59791 236.108 0.0283203 239.366 0.0283203C242.623 0.0283203 245.178 2.59791 245.178 6.06686C245.178 9.53581 242.623 12.1054 239.366 12.1054C236.108 12.1054 233.553 9.53581 233.553 6.06686ZM244.113 6.06686C244.113 3.14752 242.115 0.977642 239.366 0.977642C236.644 0.977642 234.618 3.14752 234.618 6.06686C234.618 9.01476 236.637 11.1846 239.366 11.1846C242.115 11.1775 244.113 9.00762 244.113 6.06686ZM236.887 2.81918H239.902C241.12 2.81918 242.143 3.49013 242.143 4.68928C242.143 5.41019 241.781 5.96694 241.071 6.20962V6.25958C241.656 6.43803 241.872 6.80919 241.997 7.40876C242.143 8.20819 242.046 8.95766 242.289 9.079V9.20034H240.633C240.458 9.10041 240.438 8.35095 240.368 7.72996C240.319 7.15894 240.006 6.88057 239.393 6.88057H238.565V9.20034H236.887V2.81918ZM238.565 5.6386H239.609C240.194 5.6386 240.486 5.38878 240.486 4.91768C240.486 4.44659 240.222 4.19677 239.609 4.19677H238.565V5.6386Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitexLogoDark);
export default __webpack_public_path__ + "static/media/nitexLogoDark.78b9145b77fc863331d2641cdf7dd5d7.svg";
export { ForwardRef as ReactComponent };